/* globals yaCounter22765936 yaCounter52537759 */

const init = (path, options) => {
	if (window.yaCounter22765936) {
		yaCounter22765936.hit(path, options);
	}

	if (window.yaCounter52537759) {
		yaCounter52537759.hit(path, options);
	}
};

export default {
	init,
};
